import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const MoreHorizontalSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="3.5" cy="7" r="1.15" fill="currentColor" />
        <circle cx="7" cy="7" r="1.15" fill="currentColor" />
        <circle cx="10.5" cy="7" r="1.15" fill="currentColor" />
      </svg>
    </div>
  )
}

export default MoreHorizontalSvg
